<template>
  <base-section
    id="story-alt"
    class="grey lighten-4"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-img
          :min-height="$vuetify.breakpoint.mdAndUp ? '500px' : '200px'"
          :height="$vuetify.breakpoint.mdAndUp ? '500px' : '200px'"
          :min-width="$vuetify.breakpoint.mdAndUp ? '600px' : '300px'"
          :src="require('@/assets/about/clay-banks-LjqARJaJotc-unsplash.jpg')"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="px-10"
      >
        <base-heading
          class="font-weight-bold py-3"
          title="Our Values"
          align="left"
        />
        <base-body
          text="你的话是我脚前的灯，是我路上的光。Your word is a lamp to my feet and a lightfor my path."
        />
      </v-col>
    </v-row>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionStoryAlt',
  
  }
</script>

<style lang="scss" scoped>

</style>
